module.exports = __webpack_public_path__ + "lecteurs.png?fb6f078bd07dd9fe8e881293b4440442";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lecteurs.png
// module id = 191
// module chunks = 0